import { t } from '../../i18n'
import { capitalizeWords } from '../../ts-utils'

/**
 * Why the team schedule's Add Event action is disabled.
 *
 * Creating an event needs a roster, and `resolveRosterIdFromFilters` returns
 * nothing while the filters sit on "All Seasons", while they are still
 * loading, or when the team is not in the selected competition. Without a
 * roster the form fails on save, so the action is gated up front — this is the
 * sentence that says so.
 *
 * The noun is tenant-aware: `common:competition` reads "competition" on
 * SportNinja and "season" on Canlan, so one string serves both. Web shows it
 * as the disabled button's tooltip, mobile as an alert on tap; the copy lives
 * here so the two cannot drift.
 */
export const getAddEventDisabledReason = (): string =>
  capitalizeWords(`Select a ${t('common:competition')} first`)
